module.exports = __webpack_public_path__ + "c.no1.1f67a5d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/c.no1.jpg
// module id = TFnG
// module chunks = 0